var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name === null)?_c('div',{style:([_vm.styleObject, {cursor: _vm.pointer}])},[_vm._v("....")]):_c('div',{class:{'profile-name': _vm.isNavigable, 'profile-name-hover': _vm.isClicking},style:([_vm.styleObject, {cursor: _vm.pointer}]),attrs:{"title":"进入我的 Space"},on:{"click":_vm.navigate}},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ea8842a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/Name.vue
// module id = null
// module chunks = 